import FullWidthModal from './FullWidthModal'
import ModalContent from './ModalContent'
import { FormProps, FormContainerProps } from './interface'

export { ModalContent, type FormProps, type FormContainerProps }

export default FullWidthModal
